import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import LandingPage from './components/public/landing/LandingPage';
import AboutPage from './components/public/about/AboutPage';
import FaqPage from './components/public/faq/FaqPage';
import BlogPage from './components/public/blog/BlogPage';
import DemoPage from './components/public/demo/DemoPage';
import LoginPage from './components/tool/pages/LoginPage';
import ServiceHomePage from './components/tool/pages/ServiceHomePage';
import QualityImprovementPage from './components/tool/pages/QualityImprovementPage';
import ReportPage from './components/tool/pages/ReportPage';
import MedicInfoPage from './components/tool/pages/MedicInfoPage';
import MedicReportPage from './components/tool/pages/MedicReportPage';
import MedicReportEncryptedPage from './components/tool/pages/MedicReportEncryptedPage';
import AgencySettingsPage from './components/tool/pages/AgencySettingsPage';
import AgencyListPage from './components/tool/pages/AgencyListPage';
import UserListPage from './components/tool/pages/UserListPage';
import PDFPage from './components/tool/pages/PDFPage';
import EpcrPage from './components/public/demo_new/EpcrPage';
import DemoModeContext from './models/DemoModeContext';
import './App.css';

function App() {

    const [user, setUser] = useState(null); // reset user state every time the app is mounted - prevents direct access of protected pages, even while logged in
    const [flags, setFlags] = useState(null);
    const [adminUser, setAdminUser] = useState(null); // the admin's own session, stashed while in demo mode

    const demoMode = {
        isDemoMode: adminUser !== null,
        adminUser: adminUser,
        enterDemoMode: (demoUser) => {
            setAdminUser(user);
            setUser(demoUser);
        },
        exitDemoMode: () => {
            setUser(adminUser);
            setAdminUser(null);
        }
    };

    return (
        <DemoModeContext.Provider value={demoMode}>
        <Router>
            <div className="App">
                {/* keyed on demo mode so every page remounts and refetches when the user is swapped
                    (not on user, which changes mid-login before MFA) */}
                <Routes key={adminUser ? 'demo' : 'own'}>
                    {/* Open routes - accessible by anyone */}
                    <Route path="/login" element={<LoginPage onLogin={setUser} />} />

                    <Route path="/" element={<LandingPage/>} />

                    <Route path="/about" element={<AboutPage/>} />

                    <Route path="/faq" element={<FaqPage/>} />

                    <Route path="/blog" element={<BlogPage/>} />

                    <Route path="/demo" element={<DemoPage/>} />

                    <Route path="/medic-report-encrypted/:reportIdEncrypted" element={<MedicReportEncryptedPage/>} />

                    {/* PDF generation route - accessible without authentication for server-side PDF generation */}
                    <Route path="/pdf" element={<PDFPage/>} />

                    {/* ePCR editor demo — public, uses static sample report.json */}
                    <Route path="/demo_new" element={<EpcrPage/>} />

                    {/* Protected routes - only accessible when user is logged in */}
                    {user ? (
                        <Route
                            path="/home"
                            element={<ServiceHomePage user={user} flags={flags}/>}
                        />
                    ) : null}

                    {user ? (
                        <Route
                            path="/qi"
                            element={<QualityImprovementPage user={user} flags={flags}/>}
                        />
                    ) : null}

                    {user ? (
                        <Route
                            // path="/report"
                            path="/report/:reportId"
                            element={<ReportPage user={user} flags={flags}/>}
                        />
                    ) : null}

                    {user ? (
                        <Route
                            path="/medic-report/:reportId"
                            element={<MedicReportPage user={user} flags={flags}/>}
                        />
                    ) : null}

                    {user ? (
                        <Route
                            path="/medic-info"
                            element={<MedicInfoPage user={user} flags={flags}/>}
                        />
                    ) : null}

                    {user ? (
                        <Route
                            path="/agency-settings"
                            element={<AgencySettingsPage user={user} flags={flags}/>}
                        />
                    ) : null}

                    {user ? (
                        <Route
                            path="/agency-list"
                            element={<AgencyListPage user={user} flags={flags}/>}
                        />
                    ) : null}

                    {user ? (
                        <Route
                            path="/user-list"
                            element={<UserListPage user={user} flags={flags}/>}
                        />
                    ) : null}

                    {/* Redirect to /login when no user is logged in, or if page is not routed*/}
                    <Route
                        path="/*" element={<Navigate to="/" />}
                    />
                </Routes>
            </div>
        </Router>
        </DemoModeContext.Provider>
    );
}

export default App;
